import { Actor, Engine, vec } from 'excalibur';
import { Images } from './resources';
import { TutorialLevel } from './tutorialLevel';
import { EventsManager } from '@game-libs/events-manager';

export class DragonShadow extends Actor {
  constructor() {
    super({
      width: 1000,
      height: 600,
      anchor: vec(0.5, 1),
      z: 2000,
    });

    this.graphics.use(Images.DragonShadow.toSprite());
    this.graphics.opacity = 0;

    this.scale = vec(2, 2);
    this.actions.fade(0.6, 1000);
  }

  onAdd(engine: Engine): void {
    const { emit } = EventsManager();
    this.pos = vec(engine.halfCanvasWidth, 100);

    const targetYPosition =
      (engine.currentScene as TutorialLevel).getOffsetPosition().y * 1.2;

    this.actions
      .moveTo(
        vec(engine.halfCanvasWidth, targetYPosition),
        (targetYPosition - 100) / 7.5
      ).callMethod(() => {
        emit('flash_now');
        emit('dad_dragon_reveal');
      });
    // .repeatForever((ctx) => {
    //   ctx.moveTo(vec(engine.halfCanvasWidth, targetYPosition), 10);
    //   ctx.moveTo(vec(engine.halfCanvasWidth, targetYPosition - 10), 10);
    // });
  }
}
